var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253,
    height: 253,
    viewBox: "0 0 253 253",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_26895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6735 144.532C48.1706 143.845 46.655 143.187 45.1203 142.561L0 187.616V194.133L49.6735 144.532Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1813 148.293C55.7676 147.52 54.338 146.776 52.8893 146.061L0 198.874V205.392L57.1813 148.293Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9393 157.071C69.6976 156.156 68.4399 155.262 67.1631 154.391L0 221.457V227.908L70.9393 157.071Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2309 162.05C76.0528 161.052 74.8557 160.076 73.6362 159.122L0 232.652V239.17L77.2309 162.05Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7039 141.232C40.1056 140.637 38.4945 140.074 36.8643 139.547L0 176.358V182.875L41.7039 141.232Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4935 134.628C12.5226 134.389 10.5358 134.199 8.53628 134.059L0 142.583V149.101L14.4935 134.628Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 137.839L4.02138 133.824C2.68729 133.779 1.34683 133.754 0 133.754V137.839Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1404 167.404C82.0355 166.333 80.9084 165.287 79.7654 164.257L0 243.91V250.428L83.1404 167.408V167.404Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1888 136.205C22.3612 135.83 20.5176 135.496 18.6614 135.207L0 153.841V160.359L24.1888 136.205Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2281 138.437C31.5247 137.944 29.8022 137.489 28.0701 137.073L0 165.099V171.617L33.2281 138.437Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3039 152.506C62.9603 151.647 61.5943 150.814 60.2125 150.007L0 210.132V216.717L64.3039 152.506Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.909 234.022C117.613 232.172 117.276 230.337 116.894 228.519L92.377 253H98.9041L117.909 234.022Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.021 224.649C115.598 222.92 115.136 221.209 114.64 219.511L81.1025 253H87.6297L116.021 224.649Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.519 215.89C112.987 214.265 112.42 212.657 111.822 211.064L69.8247 253H76.3551L113.519 215.89Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.088 244.104C118.941 242.114 118.744 240.136 118.502 238.174L103.655 253H110.182L119.091 244.104H119.088Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.336 248.6L114.929 253H119.419C119.419 251.528 119.39 250.059 119.339 248.6H119.336Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.977 192.585C102.187 191.247 101.372 189.924 100.532 188.617L36.0557 253H42.4714L102.977 192.582V192.585Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8611 179.273C92.8995 178.055 91.9157 176.857 90.9064 175.677L13.4717 253H20.0243L93.8579 179.273H93.8611Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6367 185.769C97.7547 184.481 96.8504 183.212 95.9175 181.963L24.7744 253.003H31.3048L98.6367 185.769Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.95 199.901C106.228 198.451 105.476 197.02 104.696 195.609L47.2188 253.003H53.7714L106.95 199.901Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.481 207.662C109.848 206.126 109.185 204.606 108.491 203.106L58.5249 253H65.0776L110.481 207.662Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.69 173.153C87.6552 172.005 86.5981 170.879 85.5187 169.773L2.17139 253H8.72404L88.69 173.149V173.153Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 132.498V33.4154C21.5312 28.4365 25.5717 24.4019 30.5579 24.4019H220.06C225.046 24.4019 229.086 28.4365 229.086 33.4154V46.5145",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 132.498V33.4154C21.5312 28.4365 25.5717 24.4019 30.5579 24.4019H220.06C225.046 24.4019 229.086 28.4365 229.086 33.4154V46.5145",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 -0.000244141H199.604V53.3181H253V-0.000244141Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.355 185.896L162.763 48.6128H68.167L113.217 190.49C115.755 198.486 109.779 206.641 101.379 206.641H191.146C201.936 206.641 209.616 196.165 206.352 185.896H206.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.217 190.49L68.1672 48.6128H61.2388L68.5939 71.7747L76.4997 96.6693L106.426 190.916C107.502 194.308 104.968 197.768 101.402 197.768H92.5884C90.2928 197.768 88.2582 196.283 87.5641 194.095L56.6284 96.6693H49.6714L81.0624 195.526C83.1638 202.146 89.3153 206.641 96.2691 206.641H101.379C109.779 206.641 115.758 198.486 113.217 190.49Z",
    fill: "#005FC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.585 197.767H101.398C104.964 197.767 107.499 194.308 106.423 190.916L76.4963 96.6692H56.625L87.5607 194.095C88.2548 196.283 90.2862 197.767 92.585 197.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2388 48.6128L68.5938 71.7747L61.2388 48.6128Z",
    fill: "#6F7C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.473 53.9987L162.763 48.6128H61.2386L106.423 190.913C107.499 194.305 104.964 197.764 101.398 197.764H92.585C90.2894 197.764 88.2548 196.28 87.5607 194.092L56.625 96.6661",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4424 180.98L81.0624 195.526C83.1638 202.145 89.3153 206.641 96.2691 206.641H191.146C201.936 206.641 209.616 196.165 206.352 185.896L177.525 95.1113",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4965 96.666H49.6714L64.9577 144.812",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.167 48.6128L113.217 190.49C115.755 198.486 109.779 206.641 101.379 206.641",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9951 64.8977H153.04",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2373 106.605H166.282",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.479 113.657H171.227",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1792 71.7747H159.933",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1294 99.9631H168.883",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.739 120.779H147.678",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.424 167.029H185.468",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.666 174.081H190.413",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.926 181.203H166.865",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.082 93.509H154.829",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2363 78.2542H141.45",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.866 136.927H168.883",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05 143.801H182.804",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.107 150.283H179.451",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.374 108.789H80.3458",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6377 115.911H82.6063",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3223 162.161H97.2941",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5605 169.213H99.5323",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8247 176.335H101.793",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7642 132.059H87.736",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9482 138.933H89.9169",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0054 145.412H91.9772",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_26895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253,
    height: 253,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.6d6dad27.svg";
export { ForwardRef as ReactComponent };